import React, { Component } from 'react';
import Loading from '../../Loading.js'
import FormTable from '../../../Fields/FormTable.js';
import FormDatePickerSimple from '../../../Fields/FormDatePickerSimple.js';
import ControlCv from './ControlCv.js';
import { getProjectCandidates } from '../../../Api/ExtranetActions.js';
import { getTranslation } from '../../../Utilities/GetTranslation.js';
import { getDateString, getJsonDate } from '../../../Utilities/JsonFunctions.js';
import { getFaseText, getGender, isFilterDate } from '../../../Utilities/SnsExtranetFunctions.js';

declare var globalSns;

class ExtranetProjectsCandidates extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenAll: false
        };

        this.openAll = this.openAll.bind(this);
        this.closeAll = this.closeAll.bind(this);        
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getProjectCandidates(this.props.id, globalSns.languageId, (data) => {
            const expanded = data.map(() => {return false});
            this.setState({
                expanded: expanded,
                projectCandidates: data
            });
        });
    }

    onNavigateCandidate(row, type) {
        this.props.onNavigate("extranetCandidates" + type, row.id, row.firstName + " " + row.name);
    }

    resetRows(isOpen) {
        const expanded = this.state.projectCandidates.map(() => {return isOpen});
        this.setState({
            expanded: expanded,
            isOpenAll: isOpen
        });        
    }

    openAll() {
        this.resetRows(true);
    }

    closeAll() {
        this.resetRows(false);
    }

    render() {
        if (this.state.projectCandidates == null) {
            return (
                <Loading/>
            );
        }

        var columns = [   
            {
                Header: () => {
                    if (this.state.isOpenAll) {
                        return (
                            <a onClick={this.closeAll}>
                                <i className="fa fa-caret-down" aria-hidden="true"></i><span className="sr-only">Close</span>
                            </a>
                        );
                    } else {
                        return (
                            <a onClick={this.openAll}>
                                <i className="fa fa-caret-right" aria-hidden="true"></i><span className="sr-only">Open</span>
                            </a>
                        );
                    }
                    
                },
                expander: true
            },        
            {
                Header: getTranslation("sns.general.name"),
                accessor: "name",
                Cell: row => (
                    <a onClick={(e) => this.onNavigateCandidate(row.row._original, "Fiche")}>{row.value}</a>
                )
            },
            {
                Header: getTranslation("sns.general.firstname"),
                accessor: "firstName",
                Cell: row => (
                    <a onClick={(e) => this.onNavigateCandidate(row.row._original, "Fiche")}>{row.value}</a>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.entrydate"),
                accessor: "entryDate",
                filterMethod: (filter, row) => {
                    return isFilterDate(filter.value, row[filter.id]);
                },                
                Filter: ({filter, onChange}) => {
                    return (
                        <FormDatePickerSimple onChange={event => onChange(event.target.value)} />
                    );
                },
                Cell: row => (
                    <span>{getDateString(getJsonDate(row.value))}</span>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.fase"),
                accessor: "projectFase",
                Cell: row => (
                    <span className={"projectStatus" + row.row._original.projectStatus}>{getFaseText(row.row._original.projectFase)}</span>
                ),
                Filter: ({filter, onChange}) => {
                    return (
                        <div className="select-wrapper">
                            <select
                                onChange={event => onChange(event.target.value)}
                                value={filter ? filter.value : ""}>
                                <option value=""></option>
                                <option value="0">{getFaseText(0)}</option>
                                <option value="1">{getFaseText(1)}</option>
                                <option value="2">{getFaseText(2)}</option>
                                <option value="3">{getFaseText(3)}</option>
                                <option value="4">{getFaseText(4)}</option>
                                <option value="5">{getFaseText(5)}</option>
                                <option value="6">{getFaseText(6)}</option>
                                <option value="7">{getFaseText(7)}</option>
                                <option value="8">{getFaseText(8)}</option>
                                <option value="9">{getFaseText(9)}</option>
                            </select>
                        </div>
                    );
                }
            },
            {
                Header: getTranslation("sns.general.extranet.onlinecv"),
                accessor: "showOnlineCv",
                filterable: false,
                Cell: row => {
                    if (row.value) {
                        return <ControlCv className="text-center" jobId={this.props.id} candidateId={row.row._original.id} />;
                    } else {
                        return "";
                    }
                }
            },
            {
                Header: getTranslation("sns.general.extranet.documents"),
                accessor: "nrDocuments",
                filterable: false,
                Cell: row => (
                    <a className="subcatlink" onClick={(e) => this.onNavigateCandidate(row.row._original, "Documents")}><span className="alignnumeric">{row.value}</span> <i className="fa fa-paperclip" aria-hidden="true"></i></a>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.messages"),
                accessor: "nrMessages",
                filterable: false,
                Cell: row => (
                    <a className="subcatlink" onClick={(e) => this.onNavigateCandidate(row.row._original, "Messages")}><span className="alignnumeric">{row.value}</span> <i className="fa fa-envelope-o" aria-hidden="true"></i></a>
                )
            }
        ]

        var subColumns = [
            {
                Header: getTranslation("sns.general.extranet.gender"),
                accessor: "gender",
                Cell: row => {;
                    return getGender(row.value);
                }
            },
            {
                Header: getTranslation("sns.general.extranet.age"),
                accessor: "age"
            },
            {
                Header: getTranslation("sns.general.extranet.place"),
                accessor: "place",
                Cell: row => (<span title={row.value}>{row.value}</span>)
            },
            {
                Header: getTranslation("sns.general.extranet.education"),
                accessor: "education",
                Cell: row => (<span title={row.value}>{row.value}</span>)
            },
            {
                Header: getTranslation("sns.general.extranet.experience"),
                accessor: "experience",
                Cell: row => (<span title={row.value}>{row.value}</span>)
            },
            {
                Header: getTranslation("sns.general.extranet.currentsalary"),
                accessor: "currentSalary",
                Cell: row => (<span title={row.value}>{row.value}</span>)
            },
            {
                Header: getTranslation("sns.general.extranet.preferredsalary"),
                accessor: "preferredSalary",
                Cell: row => (<span title={row.value}>{row.value}</span>)
            },
            {
                Header: getTranslation("sns.general.extranet.availability"),
                accessor: "availability",
                Cell: row => (<span title={row.value}>{row.value}</span>)
            }
        ]

        return (
            <div className="container-fluid">
                <div className="row">
                    <FormTable 
                        data={
                            this.state.projectCandidates                                        
                        }
                        columns={columns}
                        filterable={true}
                        expanded={this.state.expanded}
                        onExpandedChange={
                            (newExpanded, index) => {
                                this.setState(
                                    (oldState) => {
                                        const itemIndex = index[0];
                                        const isExpanded = oldState.expanded[itemIndex];
                                        const newList = oldState.expanded;
                                        newList[itemIndex] = !isExpanded;
                                        return {
                                            expanded: newList
                                        };
                                    }
                                );
                            }
                        }                        
                        SubComponent={
                            row => {
                                return (
                                    <div className="subComponent">
                                        <FormTable
                                            data={[row.original]}
                                            columns={subColumns} />
                                    </div>
                                )
                            }
                        }
                        defaultSorted={[{id:"entryDate", desc: true}]}
                    />
                </div>
            </div>
        );
    }
}

export default ExtranetProjectsCandidates;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetProjectsCandidates.js